export default "__VITE_ASSET__a5WrJnz6__"